import React from 'react';
import { Link } from 'react-router';
import {
  ArrowRight,
  Beaker,
  Compass,
  MessageCircle,
  Play,
  Settings
} from 'lucide-react';
import GrowthBadges from './GrowthBadges';
import StoreBadges from './StoreBadges';

const getExternalUrl = (value) => {
  const configured = value?.trim();
  if (!configured) return '';

  try {
    const url = new URL(configured);
    return url.protocol === 'https:' ? url.toString() : '';
  } catch {
    return '';
  }
};

// Read and Practice are now real workflows (BibleHub, PracticeDashboard); More
// stays a list because it genuinely is one — utilities, not a path to walk down.
const getMoreLinks = () => {
  const communityUrl = getExternalUrl(process.env.REACT_APP_SLACK_COMMUNITY_URL);

  return [
    ['Prayer Lab', 'Create clearly labeled AI-assisted prayers and try custom voices.', '/prayer-lab', Beaker],
    ['Verse Studio', 'Pause with curated verse artwork and open the video playlist when it is available.', '/verse-studio', Play],
    ...(communityUrl ? [[
      'Community',
      'Join the Verse Delivery community for prayer and conversation.',
      communityUrl,
      MessageCircle,
      true
    ]] : []),
    ['Resources', 'Explore practical guides for a deeper practice.', '/more/resources', Compass],
    ['Settings', 'Manage delivery destinations, notifications, ambience, and your account.', '/settings', Settings]
  ];
};

export default function SpaceHub() {
  return (
    <div className="vd-hub-shell">
      <main className="vd-hub">
        <h1>More</h1>
        <p>Creative tools, resources, and settings—ready when you want them.</p>
        <div className="vd-hub-list">
          {getMoreLinks().map(([title, body, to, Icon, external]) => {
            const content = (
              <>
                <span><Icon size={22} aria-hidden="true" /></span>
                <div><h2>{title}</h2><p>{body}</p></div>
                <ArrowRight size={19} aria-hidden="true" />
              </>
            );

            return external ? (
              <a href={to} target="_blank" rel="noreferrer" key={title}>{content}</a>
            ) : (
              <Link to={to} key={title}>{content}</Link>
            );
          })}
        </div>
        <StoreBadges />
      </main>
    </div>
  );
}

export function PracticeMerits() {
  return (
    <div className="vd-hub-shell">
      <main className="vd-hub vd-hub-merits">
        <Link className="vd-hub-back" to="/practice">← My Practice</Link>
        <h1>Merits &amp; growth</h1>
        <p>A lighthearted record of real steps in your practice—not a measure of faith.</p>
        <GrowthBadges />
      </main>
    </div>
  );
}
